/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import $ from "jquery";
import C from "okpay/util/Constants";
import OkC from "shared/util/OkcApi";
import getAccessToken from "shared/util/getAccessToken";

const WebUtil = {};


// ==============================================================================
// Confirm purchases
// ------------------------------------------------------------------------------

let _confirmPurchaseCalling = false;

WebUtil.confirmPurchase = (S) => {
	// if it's not valid yet, clear that shit
	let useNewBilling;

	if (!S.isPaymentValid) {
		return Promise.reject([{ text: "You missed something!" }]);
	}

	// if there's already a call out there, GTFO
	if (_confirmPurchaseCalling) {
		return Promise.reject({ isAlreadyRunning: true });
	}

	const path = S.product.paymentpage;
	const { productId } = S.product;
	const selectedOption = S.product.options[S.product.optionPicked];
	const productController = window[`${productId}_controller`];

	// you can go to the enter credit card form, then go to paypal,
	// and pay with existing paypal. sorry this is confusing.
	const forcePaypal = S.hasPaypal && (S.billingType === C.billingTypes.paypal);

	if (S.useBillingInfo && (S.useBillingInfo === C.activePaymentMethod[S.activePaymentMethod])) {
		useNewBilling = 0;
	} else if (forcePaypal) {
		useNewBilling = 0;
	} else {
		useNewBilling = 1;
	}

	// set base data
	let data = {
		// always pass
		okc_api: 1,
		billingsubmission: 1,
		save_info: 1,

		product: productId,
		firstname: S.firstName,
		lastname: S.lastName,
		zip: S.zipCode,
		code: S.securityCode,
		expiration: S.expiration.replace(/[^\d]/gi, ""),
		number: S.cardNumber,
		email: S.email,

		useNewBilling,

		authcode: getAccessToken(),
	};

	if (S.cf != null ? S.cf.length : undefined) {
		data.cf = S.cf.join(",");
	}

	// put any additional data into a separate object we'll mix in later
	const additionalData = { ...(selectedOption.data || {}) };

	if ((S.useBillingInfo === C.billingTypes.paypal) || forcePaypal) {
		additionalData.paypal = 1;
	}

	if (productId === "update") {
		additionalData.addcard = 1;
	}

	if (S.product.feature) {
		additionalData.feature = S.product.feature;
		additionalData.buySubscription = 1;
		additionalData.page = 3;
		additionalData.save_info = 1;
	}

	// mix that shit in
	data = { ...data, ...additionalData };

	const getCallbackSuccess = (resolve, reject) =>
		(res) => {
			_confirmPurchaseCalling = false;
			const { status, messages } = res;

			// 0 == error
			if ((status === 0) && messages) {
				window.util.updateStats(
					"quickbuy - handle errors",
					1,
					"counter",
					"dWcNlu9nl1IQU6ybxhgAzLK7esc=",
				);
				return reject(messages);
			}

			// 2 == availability error
			if (status === 2) {
				return reject(messages);
			}

			// 1 == success
			if (status === 1) {
				productController.on_product_success(res);
				return resolve(res);
			}
		};

	const getCallbackFailure = (resolve, reject) =>
		(response) => {
			_confirmPurchaseCalling = false;
			return reject(response);
		};

	return new Promise(
		((resolve, reject) => {
			// Callbacks
			// ------------------------------------------------------------------

			_confirmPurchaseCalling = true;


			// Calls
			// ------------------------------------------------------------------

			if (S.pubexpress) {
				return OkC.post("/payments/purchase", {
					data,
					api: 1,
				})
					.then(getCallbackSuccess(resolve, reject))
					.catch(getCallbackFailure(resolve, reject));
			} else {
				return $.ajax(path, {
					data,
					type: "POST",
				})
					.done(getCallbackSuccess(resolve, reject))
					.fail(getCallbackFailure(resolve, reject));
			}
		}));
};


export default WebUtil;



// WEBPACK FOOTER //
// ./src/reflux/okpay/util/WebUtil.js